import { useEffect, useState } from "preact/hooks";
import { t } from "../i18n";
import { authEnabled, getSession, logoutAccount, subscribeAuth, type AuthSession } from "../app/auth";
import { hrefFor, parseRoute } from "../app/router";

export function AccountBar() {
  const [session, setSession] = useState<AuthSession>(getSession);
  const [busy, setBusy] = useState(false);

  useEffect(() => subscribeAuth(setSession), []);

  if (!authEnabled()) return null;

  const onResults = parseRoute().name === "my-results";

  if (!session.email) {
    return (
      <div class="obs-account-slot">
        <a href={hrefFor("/my-results")} aria-current={onResults ? "page" : undefined}>
          {t("account.login")}
        </a>
      </div>
    );
  }

  return (
    <div class="obs-account-slot">
      <a href={hrefFor("/my-results")} aria-current={onResults ? "page" : undefined}>
        {t("account.myResults")}
      </a>
      <button
        class="obs-nav-quiet"
        type="button"
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          try {
            await logoutAccount();
          } finally {
            setBusy(false);
          }
        }}
      >
        {t("account.logout")}
      </button>
    </div>
  );
}
